import * as fromRootStore from '../reducers/index'
import * as fromCommon from './reducers/common.reducer';
import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

export interface AppState {
    common: fromCommon.State
}

// This is a lazy loaded state, so we need to extend from the App Root State
export interface State extends fromRootStore.State {
    'appState': AppState
}

export const reducers = {
    common: fromCommon.reducer
};

//SKU MODULE

export const getCommonRootState = createFeatureSelector<AppState>('appState');

export const getCommonState = createSelector(
    getCommonRootState,
    (state: AppState) => state.common
);

export const getAuth = createSelector(
    getCommonState,
    fromCommon.getAuth
);

export const getAllItem = createSelector(
    getCommonState,
    fromCommon.getAllItem
);

export const getAllParty = createSelector(
    getCommonState,
    fromCommon.getAllParty
);

export const getAllCompany = createSelector(
    getCommonState,
    fromCommon.getAllCompany
);


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/store/index.ts